import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

type Props = {
  defaultEmail?: string;
  onBack: () => void;
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  background: 'var(--dark-3)',
  border: '1px solid rgba(201,168,76,0.2)',
  color: 'var(--text)',
  padding: '12px 16px',
  borderRadius: '4px',
  fontSize: '14px',
  outline: 'none',
};

// Reusable "forgot password" panel. Drop this into any login screen —
// it sends a Supabase password recovery email that lands on /reset-password.
const ForgotPasswordPanel = ({ defaultEmail = '', onBack }: Props) => {
  const [email, setEmail] = useState(defaultEmail);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setError('');
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setLoading(true);
    const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (resetError) {
      setError(resetError.message);
    } else {
      setSent(true);
    }
  };

  return (
    <div>
      <h1 className="serif" style={{ color: 'var(--gold)', fontSize: '28px', fontWeight: 300, marginBottom: '8px' }}>
        Reset Password
      </h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '13px', marginBottom: '32px' }}>
        {sent ? 'Check your inbox for a reset link.' : "Enter your account email and we'll send you a reset link."}
      </p>

      {sent ? (
        <p style={{ color: '#4ade80', fontSize: '14px', marginBottom: '24px' }}>
          ✅ If an account exists for that email, a reset link is on its way.
        </p>
      ) : (
        <>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSend()}
            style={{ ...inputStyle, marginBottom: '16px' }}
          />
          {error && <p style={{ color: '#f87171', fontSize: '13px', marginBottom: '16px' }}>{error}</p>}
          <button onClick={handleSend} className="btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </>
      )}

      <button onClick={onBack} className="btn-ghost" style={{ width: '100%', marginTop: '16px' }}>
        ← Back to Login
      </button>
    </div>
  );
};

export default ForgotPasswordPanel;
